import { render, staticRenderFns } from "./PlanSelectPage.vue?vue&type=template&id=3db81b68"
import script from "./PlanSelectPage.vue?vue&type=script&lang=ts"
export * from "./PlanSelectPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports